// Eskiden buradaki tüm görseller sahte/kırık bir CDN'e (eticaret.com/cdn/...)
// işaret ediyordu ve 404 dönüyordu — sitedeki neredeyse tüm dekoratif görseller
// (hero, kategoriler, Instagram feed, üretim süreci) kırık resim ikonu gösteriyordu.
// Gerçek, doğrulanmış görsellerle değiştirildi: yerel varlıklar + Unsplash.
const UNSPLASH = 'https://images.unsplash.com';

const IMAGES = {
  logos: {
    main: '/logo-anadolu.png',
    footer: '/logo-anadolu.png',
  },

  banners: {
    hero: '/premium-hero.png',
    craftsman: '/master-craftsman.png',
  },

  products: {
    baklava:  '/premium-hero.png',
    kunefe:   `${UNSPLASH}/photo-1499636136210-6f4ee915583e?w=1200&q=80`,
    borek:    `${UNSPLASH}/photo-1601050690597-df0568f70950?w=1200&q=80`,
    manti:    `${UNSPLASH}/photo-1512058564366-18510be2db19?w=1200&q=80`,
    sarma:    `${UNSPLASH}/photo-1541518763669-27fef04b14ea?w=1200&q=80`,
    dondurma: `${UNSPLASH}/photo-1497034825429-c343d7c6a68f?w=1200&q=80`,
    zeytinyagi: `${UNSPLASH}/photo-1509440159596-0249088772ff?w=1200&q=80`,
    simit:    `${UNSPLASH}/photo-1560684352-8497838a2229?w=1200&q=80`,
  },

  categories: {
    tatlılar:      `${UNSPLASH}/photo-1587132137056-bfbf0166836e?w=1200&q=80`,
    hamurIsleri:   `${UNSPLASH}/photo-1560684352-8497838a2229?w=1200&q=80`,
    anaYemekler:   `${UNSPLASH}/photo-1541518763669-27fef04b14ea?w=1200&q=80`,
    dondurma:      `${UNSPLASH}/photo-1497034825429-c343d7c6a68f?w=1200&q=80`,
    bakkaliye:     `${UNSPLASH}/photo-1481931098730-318b6f776db0?w=1200&q=80`,
  },

  process: {
    harvest:   '/master-craftsman.png',
    dough:     `${UNSPLASH}/photo-1601050690597-df0568f70950?w=1200&q=80`,
    packaging: `${UNSPLASH}/photo-1592841200221-a6898f307baa?w=1200&q=80`,
  },

  instagram: [
    `${UNSPLASH}/photo-1488477181946-6428a0291777?w=800&q=80`,
    `${UNSPLASH}/photo-1556910103-1c02745aae4d?w=800&q=80`,
    `${UNSPLASH}/photo-1517686469429-8bdb88b9f907?w=800&q=80`,
    `${UNSPLASH}/photo-1600891964092-4316c288032e?w=800&q=80`,
    `${UNSPLASH}/photo-1490645935967-10de6ba17061?w=800&q=80`,
    `${UNSPLASH}/photo-1568901346375-23c9450c58cd?w=800&q=80`,
  ],

  payment: {
    bancontact: '/brands/Bancontact-Original-logo-RGB.svg',
    mastercard: '/brands/mastercard.svg',
    visa:       '/brands/visa.svg',
    stripe:     '/brands/stripe.svg',
  }
};

export default IMAGES;
